import { useEffect, useState } from 'react';

import { useGetLanguageInfo } from './useGetLanguageInfo';

export const useDateLocal = () => {
  const { langSelected } = useGetLanguageInfo();

  const [dateLocale, setDateLocale] = useState<string>('en');

  const loadLocale = async (locale: string) => {
    switch (locale) {
      case 'ja':
        await import('dayjs/locale/ja');
        setDateLocale('ja');
        break;
      case 'en':
        await import('dayjs/locale/en');
        setDateLocale('en');
        break;
      case 'zh-hans':
        await import('dayjs/locale/zh-cn');
        setDateLocale('zh-cn');
        break;
      case 'zh-hant':
        await import('dayjs/locale/zh-tw');
        setDateLocale('zh-tw');
        break;
      case 'ko':
        await import('dayjs/locale/ko');
        setDateLocale('ko');
        break;
      case 'vi':
        await import('dayjs/locale/vi');
        setDateLocale('vi');
        break;
      case 'pt':
        await import('dayjs/locale/pt');
        setDateLocale('pt');
        break;
      case 'pt-br':
        await import('dayjs/locale/pt-br');
        setDateLocale('pt-br');
        break;
      case 'id':
        await import('dayjs/locale/id');
        setDateLocale('id');
        break;
      case 'ne':
        await import('dayjs/locale/ne');
        setDateLocale('ne');
        break;
      case 'es':
        await import('dayjs/locale/es');
        setDateLocale('es');
        break;
      case 'my':
        await import('dayjs/locale/my');
        setDateLocale('my');
        break;
      default:
        await import('dayjs/locale/en');
        setDateLocale('en');
        break;
    }
  };

  useEffect(() => {
    const value = langSelected?.value.toLocaleLowerCase() || 'en';
    loadLocale(value);
  }, [langSelected]);

  return {
    dateLocale,
  };
};
